import React from 'react';
import { useCompassContext } from './CompassContext';

const CompassControls = () => {
  const ctx = useCompassContext();
  if (!ctx) {
    return null;
  }

  const {
    stage,
    questionIdx,
    totalQuestions,
    hasIntroStage,
    labels,
    goBack,
    startCompass,
    restartCompass,
  } = ctx;

  const hasQuestions = totalQuestions > 0;
  const showBackButton = stage === 'question' && (questionIdx > 0 || hasIntroStage);

  if (stage === 'intro') {
    return (
      <div className="col-span-12 flex gap-3">
        <button
          type="button"
          className="rounded-full bg-black text-white py-2 px-5 transition-opacity disabled:opacity-50"
          onClick={startCompass}
          disabled={!hasQuestions}
        >
          {labels?.start}
        </button>
      </div>
    );
  }

  if (stage === 'question' && showBackButton) {
    return (
      <div className="col-span-12 flex gap-3">
        <button
          type="button"
          className="rounded-full bg-yellow-60 py-2 px-5"
          onClick={goBack}
        >
          {labels?.back}
        </button>
      </div>
    );
  }

  if (stage === 'result') {
    return (
      <div className="col-span-12 flex gap-3">
        <button
          type="button"
          className="rounded-full bg-black text-white py-2 px-5"
          onClick={restartCompass}
        >
          {labels?.restart}
        </button>
      </div>
    );
  }

  return null;
};

export default CompassControls;
